// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lvqr","question":"styles_question__Ta-yo","description":"styles_description__1fEY_"};